export default __webpack_public_path__ + "static/media/AGC_2022_R2_QP_Class_4.4d84d0d7.pdf";